import * as React from 'react';
import styled from 'styled-components';
import * as is from 'is_js';
import { TextField, Colors } from '@origin-digital/style-guide';
import { EyeOnIcon, EyeOffIcon } from '../Icons';

interface IProps {
  'data-testhook'?: string;
  autoFocus?: boolean;
  className?: string;
  label?: string;
  onChange?: (e: React.ChangeEvent<React.ReactNode>) => void;
  onBlur?: (e: React.ChangeEvent<React.ReactNode>) => void;
  value: string;
  error?: string;
}

interface IState {
  showingPassword: boolean;
}

const defaultProps = {};

export class PasswordInputBase extends React.Component<IProps, IState> {
  public static defaultProps = defaultProps;

  constructor(props: IProps) {
    super(props);
    this.state = {
      showingPassword: false,
    };
  }

  public render() {
    const { autoFocus, className, label, onChange, onBlur, value, error } = this.props;

    const { showingPassword } = this.state;

    return (
      <div className={className}>
        <TextField
          autoComplete="password"
          id="password"
          name={label}
          autoFocus={autoFocus}
          label={label}
          touched={true}
          type={showingPassword ? 'text' : 'password'}
          onChange={onChange}
          markdown={true}
          onBlur={onBlur}
          value={value}
          error={error}
          autoCapitalize="off"
          spellCheck={false}
          orderHiddenInputLast={true} // workaround for firefox pw manager issue
          disableIcon={!error}
          data-id="LoginStep2__password__input"
        />
        <button
          className="PasswordInput__show-password"
          type="button"
          onClick={this.handleShowPasswordChange}
          data-id="LoginStep__password__show-password"
        >
          {showingPassword ? <EyeOnIcon /> : <EyeOffIcon />}
        </button>
      </div>
    );
  }

  private handleShowPasswordChange = () => {
    const { showingPassword } = this.state;
    this.setState({ showingPassword: !showingPassword });
  };
}

const StyledPasswordInputBase = styled(PasswordInputBase)`
  position: relative;

  .PasswordInput__show-password,
  .PasswordInput__show-password:focus {
    background: none;
    position: absolute;
    transform: translate(0, -50%);
    top: 50%;
    appearance: none;
    outline: none;
    border: none;
    width: 22px;
    height: 22px;
    padding: 0;
    right: ${(props) => (!props.error ? '13px' : '40px')};
    top: 28px;
    outline: none;
    cursor: pointer;
    visibility: ${() => (is.ie() || is.edge() ? 'hidden' : 'visible')};
  }

  .PasswordInput__show-password > svg {
    fill: ${Colors.GREY48};
    width: 100%;
  }
`;

export { StyledPasswordInputBase as PasswordInput };
